import { jsx as _jsx } from "react/jsx-runtime";
import { TONE } from '../system/tone';
export function Thumbnail({ src, tone = 'neutral', size = 44, radius = 'var(--radius-md)', children, style, }) {
    const t = TONE[tone];
    return (_jsx("div", { style: {
            width: size,
            height: size,
            borderRadius: radius,
            flexShrink: 0,
            background: src ? `url(${src}) center/cover` : t.bg,
            color: t.ink,
            position: 'relative',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...style,
        }, children: children }));
}
//# sourceMappingURL=Thumbnail.js.map